import { helper } from '@ember/component/helper';
import { dateDiff as dateDiff$1 } from 'beebee-base/lib/utility';
import moment from 'moment-timezone';

/**
 * Calcola la differenza tra due date
 * @param {string} unit - Unità di misura (days, hours, etc.)
 */
function dateDiffH([date1, date2, unit]) {
  if (!date1 || !date2) return undefined;

  // Un solo new Date() per invocazione: due chiamate separate per 'now'/'now'
  // darebbero un diff piccolo ma non-zero.
  const now = new Date();
  const resolveDate = d => d === 'now' ? now : d;
  const p0 = resolveDate(date1);
  const p1 = resolveDate(date2);
  return unit ? moment(p0).diff(p1, unit) : dateDiff$1(p0, p1);
}
var dateDiff = helper(dateDiffH);

export { dateDiffH, dateDiff as default };
//# sourceMappingURL=date-diff.js.map
